import React, { Fragment, useEffect } from "react";

import { func, string } from "prop-types";

import { countriesOptions } from "../../../../helpers";

import { TextFieldGroup, SelectListGroup } from "../../../../common";

const ManualAddress = ({
  handleChange,
  addressLine1,
  addressLine2,
  addressLine3,
  town,
  county,
  postcode,
  country,
  handleChangeToShowNextStep,
  setDisableNextFromManual = () => {},
  errors = {},
}) => {
  useEffect(() => {
    const manualAddressSelectedButNoFilled =
      addressLine1.length <= 0 ||
      town.length <= 0 ||
      county.length <= 0 ||
      postcode.length <= 0;

    if (manualAddressSelectedButNoFilled) {
      setDisableNextFromManual(true);
    } else {
      setDisableNextFromManual(false);
    }
  }, [addressLine1, town, county, postcode]);
  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label htmlFor="addressLine1">Address line 1*</label>
            <TextFieldGroup
              classes="register_field"
              value={addressLine1}
              onChange={(e) => {
                handleChange("addressLine1", e.target.value);
              }}
              validationMessageIsRed
              validationMessages={errors?.addressLine1}
            />
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="addressLine2">Address line 2</label>
                <TextFieldGroup
                  classes="register_field"
                  value={addressLine2}
                  onChange={(e) => {
                    handleChange("addressLine2", e.target.value);
                  }}
                  validationMessageIsRed
                  validationMessages={errors?.addressLine2}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="addressLine3">Address line 3</label>
                <TextFieldGroup
                  classes="register_field"
                  value={addressLine3}
                  onChange={(e) => {
                    handleChange("addressLine3", e.target.value);
                  }}
                  validationMessageIsRed
                  validationMessages={errors?.addressLine3}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="town">Town*</label>
                <TextFieldGroup
                  classes="register_field"
                  value={town}
                  onChange={(e) => {
                    handleChange("town", e.target.value);
                  }}
                  validationMessageIsRed
                  validationMessages={errors?.town}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="county">County*</label>
                <TextFieldGroup
                  classes="register_field"
                  value={county}
                  onChange={(e) => {
                    handleChange("county", e.target.value);
                  }}
                  validationMessageIsRed
                  validationMessages={errors?.county}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="postcode">Postcode*</label>
                <TextFieldGroup
                  classes="register_field"
                  value={postcode}
                  onChange={(e) => {
                    handleChangeToShowNextStep("postcode", e.target.value);
                  }}
                  validationMessageIsRed
                  validationMessages={errors?.postcode}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="country">Country</label>
                <SelectListGroup
                  classes="register_field register_field-dropdown"
                  options={countriesOptions}
                  value={country}
                  onChange={(e) => {
                    handleChangeToShowNextStep("country", e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ManualAddress.propTypes = {
  handleChange: func.isRequired,
  handleChangeToShowNextStep: func,
  addressLine1: string.isRequired,
  addressLine2: string.isRequired,
  addressLine3: string.isRequired,
  town: string.isRequired,
  county: string.isRequired,
  postcode: string.isRequired,
  country: string.isRequired,
};

export default ManualAddress;
